import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';

import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Programme } from '../types/programme';
import { Topic } from '../types/topic';

@Component({
  selector: 'topics',
  template: `<div class="topics" *ngIf="CanReview(); else notReviewer">
  <div *ngFor="let topic of topics"
       class="topic_row"
      [class.selected]="topic === currentTopic"
      [style.background-color]="this.getColorFor(topic)"
      (click)="gotoDetail(topic)">
    <span class="badge">{{topic.id}}</span>
    <span class="topic_text">{{topic.topic}}</span>
    <span class="count">{{topic.response_count}}</span>
    <span class="programme_name">{{topic.programme_name}}</span>
  </div>
  <div *ngIf="CanAdminister()">
    <div *ngIf="adding; else addmore">
      <topic-detail [inserting]="true" [programmes]="programmes" [type_id]="this.topicTypeID" (closeDetail)="closeDetail()"></topic-detail>
      <img src="/images/cancel.svg" (click)="closeDetail()" class="addlink">
    </div>
    <ng-template #addmore>
      <img src="/images/plus.svg" (click)="addTopic()" class="addlink">
    </ng-template>
  </div>
</div>
<ng-template #notReviewer>Not a reviewer.</ng-template>`,
  styleUrls: ['./topics.component.css'],
  providers: [VoxPopService],
})


export class TopicsComponent implements OnInit {
  CanReview = ProfileService.CanReview;
  CanAdminister = ProfileService.CanAdminister;
  adding = false;
  topics: Topic[];
  programmes: Programme[];
  allTopics: Topic[];
  errorMessage: any;
  topicTypeID = Topic.typeIDTopic;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) { return; }
    this.voxPopService.myActiveProgrammes().subscribe(
      programmes => this.programmes = programmes,
      error => this.errorMessage = <any>error,
    );
    document.getElementById('title').innerText = 'Topics';
    this.getTopics();
  }

  getTopics(): void {
    this.route.url.subscribe((urlSegments: UrlSegment[]) => {
      console.log(urlSegments);
      if (urlSegments.length > 1) {
        switch (urlSegments[1].path) {
          case 'topics':
            document.getElementById('title').innerText = 'Topics';
            this.topicTypeID = Topic.typeIDTopic;
            this.voxPopService.activeTopics().subscribe(
              topics => this.updatedTopics(topics),
              error => this.errorMessage = <any>error,
            );
            break;
          case 'wires':
            document.getElementById('title').innerText = 'Wires';
            this.topicTypeID = Topic.typeIDWire;
            this.voxPopService.activeWires().subscribe(
              topics => this.updatedTopics(topics),
              error => this.errorMessage = <any>error,
            );
            break;
        }
      }
    });
  }

  private updatedTopics(newTopics: Topic[]): void {
    this.allTopics = newTopics;
    this.topics = newTopics;
  }

  gotoDetail(topic: Topic): void {
    this.router.navigate(['/review/responses/topic/', topic.id]);
  }

  addTopic(): void {
    this.adding = true;
  }

  closeDetail(): void {
    this.adding = false;
    this.getTopics();
  }

  getColorFor(topic: Topic): string {
    if (this.errorMessage) { return '#ff8080'; } // So editor doesn't make me think this can be static
    if (topic.active) { return '#f4f8f8'; }
    return '#EEEEEE';
  }

}

